export const SECOND = 1000;
